import {Question} from "@/lib/Question";
import {ArrayAccessDictionary} from "@/lib/ArrayAccessDictionary";

export interface HouseOverviewForm {
    houseType: Question;
    size: Question;
    typeOfVilla: Question;
    floor: Question;
    numberOfRooms: Question;
    municipality: Question;
    neighborhood: Question;
    ownership: Question;
    [index: string]: Question;
}

export class HouseForm{
    constructor(public form: HouseOverviewForm|ArrayAccessDictionary<Question>) {
    }
}